import Vue from 'vue';
import Vuex from 'vuex';
import vuexPersist from './vuexPersist';

Vue.use(Vuex);

export default new Vuex.Store({
  // Vuex 的状态和其他选项
  plugins: [vuexPersist],
  state: {
    checkedYzList: [],
    Obj: {},
    publicHcID: null, //用来判断当前是保存回测还是还是更新回测
    type: null, //用来判断当前是保存策略还是还是更新策略
    contentNavBar: 87,
    btnDisabled: false,
    selHistory: [], //历史搜索的因子
    myTab: 'gz', // 当前我的页面的tab的类型
    smallTab: '', //子路由
    userName: '', //用户名称
    timeStr: '', //服务器时间
    cl: false, //策略弹框
    mn: false, // 模拟弹框
    hc: false, // 回测弹框
    bccl: false, //保存多因子策略弹框
    openMn: false, // 开启模拟交易弹框
    ccxy: false, // 策略超参寻优弹框
    isVip: false, // VIP默认是否
    zryyData:{}, // 自然语言数据
    vipCode:false, //vip的多权限位
  },

  //同步
  mutations: {
    setCheckedYzList(state, checkedYzList) {
      state.checkedYzList = checkedYzList; // 更新全局状态的 mutation
    },
    setObj(state, Obj) {
      state.Obj = Obj; // 更新全局状态的 mutation
    },

    //用来去编辑回测的 公共id
    setPublicHcID(state, publicHcID) {
      state.publicHcID = publicHcID; // 更新全局状态的 mutation
    },

    //用来去编辑策略的
    setType(state, type) {
      state.type = type; // 更新全局状态的 mutation
    },

    setContentNavBar(state, contentNavBar) {
      state.contentNavBar = contentNavBar; // 更新全局状态的 mutation
    },

    setBtnDisabled(state, btnDisabled) {
      state.btnDisabled = btnDisabled; // 更新全局状态的 mutation
    },

    setSelHistory(state, selHistory) {
      state.selHistory = selHistory;
    },

    setZryyData(state,zryyData) {
      state.zryyData = zryyData;
    },

    //重置Obj
    resetObj(state) {
      state.Obj = {};
    },
    resetCheckedYzList(state) {
      state.checkedYzList = [];
    },

    resetPublicHcID(state) {
      state.publicHcID = null;
    },

    resetType(state) {
      state.type = null;
    },

    resetBtnDisabled(state) {
      state.btnDisabled = false;
    },

    resetContentNavBar(state) {
      state.contentNavBar = 87;
    },

    resetSelHistory(state) {
      state.selHistory = [];
    },

    resetZryyData (state) {
      state.zryyData = {}
    },

    //重置所有的值
    resetState(state) {
      state.checkedYzList = [];
      state.Obj = {};
      state.publicHcID = null;
      state.type = null;
      state.myTab = 'gz'; // 当前我的页面的tab的类型
      state.smallTab = ''; //子路由
    },

    setMyTab(state, text) {
      state.myTab = text;
    },
    setSmallTab(state, text) {
      state.smallTab = text;
    },
    setuserName(state, text) {
      state.userName = text;
    },
    setTimeStr(state, text) {
      state.timeStr = text;
    },
    setCl(state, text) {
      state.cl = text;
    },
    setMn(state, text) {
      state.mn = text;
    },
    setHc(state, text) {
      state.hc = text;
    },
    setBccl(state, text) {
      state.bccl = text;
    },
    setOpenMn(state, text) {
      state.openMn = text;
    },
    setCcxy(state, text) {
      state.ccxy = text;
    },

    SET_IS_VIP(state, value) {
      state.isVip = value;
    },
    SET_VIP_CODE(state, value){
      state.vipCode = value;
    }
  },

  //异步
  actions: {
    checkVipStatus({ commit }) {
      function getUrlQuery(paramName) {
        var url = document.location.toString();
        var arrObj = url.split('?');
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&');
          var arr;
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');

            if (arr != null && arr[0] === paramName) {
              return arr[1];
            }
          }
          return '';
        } else {
          return '';
        }
      }


      /**
       * 判断版本号(新版)
       * @param {string} version1 - 第一个版本号
       * @param {string} version2 - 第二个版本号
       * @returns {number} - 返回版本号比较结果，0表示相等，1表示第一个版本号大于第二个版本号，-1表示第一个版本号小于第二个版本号
       * @returns {boolean} - 返回版本号比较结果，true表示第一个版本号大于或者等于第二个版本号，false表示第一个版本号小于第二个版本号
       *
       */
      function compareVersions(currentVersion,needVersion){
        currentVersion = currentVersion?currentVersion.toString():'9.00';
        needVersion = needVersion?needVersion.toString():'9.00';
        // 标准化版本号
        const version1 = normalizeVersion(currentVersion);
        const version2 = normalizeVersion(needVersion);

        // 将版本号按"."分割成数组
        const v1Parts = version1.split('.');
        const v2Parts = version2.split('.');

        const length = Math.max(v1Parts.length, v2Parts.length);

        // 定义比较结果
        let result = 0;

        // 比较每个部分
        for (let i = 0; i < length; i++) {
            // 如果某个版本号部分不存在，填充为0
            const v1Part = parseInt(v1Parts[i] || '0', 10);
            const v2Part = parseInt(v2Parts[i] || '0', 10);

            if (v1Part > v2Part) {
              result = 1; // version1 is greater than version2
              // 结束循环
              break;
            } else if (v1Part < v2Part) {
              result = -1; // version1 is smaller than version2
              // 结束循环
              break;
            }
        }
        if(result >= 0) {
          return true;
        } else {
          return false;
        }
      }

      function normalizeVersion(version) {
        // 将版本号按"."分割成数组
        const parts = version.split('.');
        // 确保数组长度为3，不足则补0
        while (parts.length < 3) {
            parts.push('0');
        }
        // 返回标准化的版本号
        return parts.join('.');
      }


      let version = getUrlQuery('version');

      if (typeof DzhAppJs != 'undefined') {

        // 优先判断老权限
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('isUserApplyVip', '', 'onBoolCallback');
        // 老权限的回调
        window.onBoolCallback = (data) => {
          console.log('data',data);

          if(data == '1') {
            // 有权限
            commit('SET_IS_VIP', true);
            // 设置创建权限
            commit('SET_VIP_CODE', true);
          } else {
            // 无老权限,根据版本号判断一下新权限
            if(compareVersions(version,9.92)){
              let paramsPower = window.APP_POWER;
              DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('getUserPowerFunc', paramsPower, 'onPowerCallback');
            } else {
              commit('SET_IS_VIP', false);
              // 设置创建权限
              commit('SET_VIP_CODE', false);
            }
          }

        };
        // 大于等于992的回调
        window.onPowerCallback = (data) => {
          console.log('data:内网权限',data);

          let paramsPower = window.APP_POWER;
          let powerInfo = JSON.parse(paramsPower);
          let dataInfo = JSON.parse(data);
          // 获取产品数组
          const products = powerInfo.products;
          // 默认无权限
          var isPower = false;


          // 输出每个产品对应的数据
          products.forEach(product => {

            if(dataInfo[product] == '1') {
              isPower = true;
            }
          });



          // 判断是否有创建权限
          if(dataInfo[216] == '1' || dataInfo[516] == '1') {
            commit('SET_VIP_CODE', true);
          } else {
            commit('SET_VIP_CODE', false);
          }

          commit('SET_IS_VIP', isPower);
        }
      }
    }
  },
  modules: {}
});
